import { render, staticRenderFns } from "./ShowUsernameModal.vue?vue&type=template&id=3aed0224&scoped=true"
import script from "./ShowUsernameModal.vue?vue&type=script&lang=js"
export * from "./ShowUsernameModal.vue?vue&type=script&lang=js"
import style0 from "./ShowUsernameModal.vue?vue&type=style&index=0&id=3aed0224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aed0224",
  null
  
)

export default component.exports